//
import "core-js/stable";

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
//
import React from 'react';
import { createRoot } from 'react-dom/client';
import Root from './components/Root.js';

// import 'core-js/stable'
// import 'regenerator-runtime/runtime'
import cssVars from 'css-vars-ponyfill';

import '../css/frontend-new.scss';

cssVars();

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<Root />);
